import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "menu" */ './Menu'),
  loading: () => null,
});
